import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./navbar.scss";
import onco_mark from "../../assets/logos/ONCOEVIDA_1.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useLogin } from "../../hooks/useLogin";
import { useTranslation } from "react-i18next";
import "../../i18n";
import i18n from "i18next";
import { useSetting } from "../../hooks/useSetting";
import ReportBugModal from "../../components/Modals/ReportBugModal";

function CustomNav() {
  const userName = localStorage.getItem("uname");
  const { signout } = useLogin();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { settingGet } = useSetting();
  const [country, setCountry] = useState(localStorage.getItem("country") || "");
  const [showBugModal, setShowBugModal] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      const settings = await settingGet();
      if (settings) {
        localStorage.setItem("theme", settings.theme);
        localStorage.setItem("language", settings.language);
        localStorage.setItem("fullName", settings.fullName);
        localStorage.setItem("gender", settings.gender);
        i18n.changeLanguage(settings.language);
        setCountry(settings.country);
        localStorage.setItem("country", settings.country);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (country === "") {
      alert(
        "Please set your country in the settings to ensure accurate data representation."
      );
      navigate("/settings?tab=account");
    }
  }, [country, navigate]);

  const handleLogout = async () => {
    try {
      await signout();
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <>
    <Navbar className="custom-nav" expand="lg">
      <Container fluid className="nav-shell">
        {/* LEFT: Logo */}
        <Navbar.Brand as={Link} to="/home-page" className="brand">
          <img className="logo" src={onco_mark} alt="OncoScreen Logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />

        <Navbar.Collapse id="main-navbar">
          {/* CENTER: Menu */}
          <Nav className="mx-auto main-nav">
            <Nav.Link as={Link} to="/home-page" className={`me-3${location.pathname === "/home-page" ? " active" : ""}`}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/single-dashboard" className={`me-3${location.pathname === "/single-dashboard" ? " active" : ""}`}>
              {t("dashboard")}
            </Nav.Link>
            <Nav.Link as={Link} to="/datasets" className={`me-3${location.pathname === "/datasets" ? " active" : ""}`}>
              {t("dataset")}
            </Nav.Link>
            <Nav.Link as={Link} to="/create-chart" className={`me-3${location.pathname === "/create-chart" ? " active" : ""}`}>
              {t("homeCreateChart")}
            </Nav.Link>
            <Nav.Link as={Link} to="/recommendations" className={`me-3${location.pathname === "/recommendations" ? " active" : ""}`}>
              {t("pageAnalytics")}
            </Nav.Link>
            <Nav.Link as={Link} to="/documentation" className={`me-3${location.pathname === "/documentation" ? " active" : ""}`}>
              {t("documentation")}
            </Nav.Link>
            <Nav.Link
              href="https://oncoscreen.health/"
              target="_blank"
              rel="noreferrer"
              className="me-3"
            >
              Oncoscreen Website
            </Nav.Link>
          </Nav>

          {/* RIGHT: Account */}
          <Nav className="ms-auto account-nav">
            <NavDropdown
              title={
                <span className="account-title">
                  <i className="bi bi-person-fill-gear" />
                  {userName}
                </span>
              }
              id="collapsible-nav-dropdown"
              align="end"
            >
              <NavDropdown.Item> </NavDropdown.Item>
              <NavDropdown.Item>@{userName}</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/settings?tab=account">
                {t("accountSettings")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/settings?tab=preferences">
                {t("preferences")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/settings?tab=password">
                {t("password")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/settings?tab=cookies">
                Cookies
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={() => setShowBugModal(true)}>
                <i className="bi bi-bug me-2" />
                {t("reportBug")}
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    {showBugModal && <ReportBugModal onClose={() => setShowBugModal(false)} />}
    </>
  );
}

export default CustomNav;
